<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} COUPON</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">


        <!-- NAME -->
        <vs-input label="Name" v-model="dataName" class="mt-5 w-full" name="coupan-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('coupan-name')">{{ errors.first('coupan-name') }}</span>

        <!-- CODE -->
        <vs-input label="Code" v-model="dataCode" class="mt-5 w-full" name="coupan-code" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('coupan-code')">{{ errors.first('coupan-code') }}</span>

        <!-- PRICE -->
        <vs-input
          icon-pack="feather"
          icon="icon-dollar-sign"
          label="Amount"
          v-model="dataAmount"
          class="mt-5 w-full"
          v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"
          name="coupan-amount" />
        <span class="text-danger text-sm" v-show="errors.has('coupan-amount')">{{ errors.first('coupan-amount') }}</span>

        <!-- Redemption Limit -->
        <vs-input label="Redemption Limit" v-model="dataRedemption" class="mt-5 w-full" name="redemption-limit" v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }" />
        <span class="text-danger text-sm" v-show="errors.has('coupan-redemption')">{{ errors.first('coupan-redemption') }}</span>

        <!-- URL -->
        <vs-input label="Url" v-model="dataUrl" class="mt-5 w-full mb-5" name="coupan-url"/>
         <!-- <span class="text-danger text-sm" v-show="errors.has('coupan-url')">{{ errors.first('coupan-url') }}</span> -->


        <!-- STATUS -->
        <!-- <vs-select v-model="dataStatus" label="Status" class="mt-5 w-full" :disabled="statusDisabled">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in status_choices" />
        </vs-select>-->
        <label for="" class="vs-input--label">Status</label>
        <v-select v-validate="'required'" class="mt-1 w-full" :disabled="statusDisabled" name="up_role" v-model="dataStatus" :options="status_choices" /><br>

        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {

      dataId: null,
      dataName: '',
      dataCode: null,
      dataStatus: {'label':'Active', 'id': 1},
      dataAmount: '',
      dataRedemption: '',
      dataUrl: '',
      statusDisabled: false,

      //status_choices: [
      // {text:'Active', value: 1},
      //{text:'In-active', value: 0}
      //],
      status_choices: [
        {'label':'Active', 'id': 1},
        {'label':'In-active', 'id': 0}
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.statusDisabled = true
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, couponName, couponCode, isActive, couponAmount, couponRedeem, url } = JSON.parse(JSON.stringify(this.data))
        
        this.dataId = id
        this.dataName = couponName
        this.dataCode = couponCode
        this.dataAmount = couponAmount
        this.dataRedemption = couponRedeem
        if (isActive == 1) {
          this.dataStatus = {'label':'Active', 'id': 1}
        } else {
          this.dataStatus = {'label':'In-active', 'id': 0}
        }
        
        this.dataUrl = url
        this.statusDisabled = false
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataCode && this.dataAmount > 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataCode = null
      this.dataAmount = ''
      this.dataRedemption = ''
      this.dataUrl = ''
      this.dataStatus = {'label':'Active', 'id': 1}
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const editFormData = new FormData()
          editFormData.append('couponID', this.dataId)
          editFormData.append('couponName', this.dataName)
          editFormData.append('couponCode', this.dataCode)
          editFormData.append('isActive', this.dataStatus.id)
          editFormData.append('couponAmount', this.dataAmount)
          editFormData.append('couponRedeem', this.dataRedemption)

          const addFormData = new FormData()
          addFormData.append('couponName', this.dataName)
          addFormData.append('couponCode', this.dataCode)
          addFormData.append('couponAmount', this.dataAmount)
          addFormData.append('couponRedeem', this.dataRedemption)

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataList/updateItem', editFormData)
              .then((resp) => {
                this.$vs.loading.close()
                this.$vs.notify({title:'Great!', text: resp.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
                this.$store.dispatch('dataList/fetchDataListItems')
              })
              .catch(err => { 
                this.$vs.loading.close()
                console.error(err)
                this.$vs.notify({title:'Great!', text: err, color:'warning', position:'top-right', icon:'error', time:5000})
              })
          } else {
            
            this.$store.dispatch('dataList/addItem', addFormData).then((resp) => {
              this.$vs.loading.close()
              this.$vs.notify({title:'Great!', text: resp.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
              this.$store.dispatch('dataList/fetchDataListItems')
            })
              .catch(err => { 
                this.$vs.loading.close()
                console.error(err)
                this.$vs.notify({title:'Great!', text: err, color:'warning', position:'top-right', icon:'error', time:5000})
              })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }  
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
